import React from "react";
import { useQuery } from "@apollo/client/react";
import { INTERNAL_WORK_ORDER_QUERY } from "src/constants/graphql/queries";
import InternalWorkOrderChargesSummaryModal from "src/views/inventory/requests/orders/InternalWorkOrderChargesSummaryModal";
import StatusDialog from "./StatusDialog";

export default function InternalWorkOrderChargesSummaryModalWrapper({
  iwoChargesSummaryId,
  onClose,
}) {
  const { data, loading, error } = useQuery(INTERNAL_WORK_ORDER_QUERY, {
    variables: { id: iwoChargesSummaryId },
    skip: !iwoChargesSummaryId,
  });

  const internalWorkOrder = data?.internalWorkOrder;

  if (!loading && error) {
    return (
      <StatusDialog
        title="Failed to load Internal Work Order Charges Summary"
        message="You may not have access to view this order, or it no longer exists."
        onClose={onClose}
      />
    );
  }

  if (internalWorkOrder) {
    return (
      <InternalWorkOrderChargesSummaryModal
        internalWorkOrder={internalWorkOrder}
        onClose={onClose}
      />
    );
  }

  return null;
}
